// extracted by mini-css-extract-plugin
export default {"visuallyHidden":"cDZ5sVvtuto0KyhIdTwT"};